import { FooterWrapper, CopyrightWrapper } from "./Styles";

const Footer = () => {
    return (
        <FooterWrapper>
            <CopyrightWrapper>
                Copyright @ 2021 quochunghoang1110
            </CopyrightWrapper>
        </FooterWrapper>
    );
};

export default Footer;
